import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-190f61e2"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
    key: 1,
    class: "action-dialog__title"
};
const _hoisted_3 = {
    key: 2,
    class: "action-dialog__desc"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "action-dialog__footer" };
import { computed, useSlots } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActionDialog',
    props: {
        modelValue: { type: Boolean },
        title: { default: '' },
        description: { default: '' },
        confirmLabel: { default: 'Confirmar' },
        cancelLabel: { default: 'Cancelar' },
        loading: { type: Boolean, default: false },
        tone: { default: 'danger' },
        showIcon: { type: Boolean, default: true }
    },
    emits: ["update:modelValue", "confirm", "cancel"],
    setup(__props, { emit }) {
        const props = __props;
        const hasTitle = computed(() => !!(props.title || useSlots().title));
        const hasDescription = computed(() => !!(props.description || useSlots().description));
        function onConfirm() {
            emit('confirm');
        }
        function onCancel() {
            emit('cancel');
            emit('update:modelValue', false);
        }
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                "model-value": _ctx.modelValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:modelValue', $event))),
                width: "358px",
                "show-close": false,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                class: "action-dialog",
                role: "dialog",
                "aria-modal": "true"
            }, {
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_button, {
                            class: "action-dialog__cancel",
                            onClick: onCancel,
                            disabled: _ctx.loading
                        }, {
                            default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "cancel-label", {}, () => [
                                    _createTextVNode(_toDisplayString(_ctx.cancelLabel), 1)
                                ])
                            ]),
                            _: 3
                        }, 8, ["disabled"]),
                        _createVNode(_component_el_button, {
                            class: _normalizeClass(["action-dialog__confirm", `action-dialog__confirm--${_ctx.tone}`]),
                            type: "primary",
                            loading: _ctx.loading,
                            onClick: onConfirm
                        }, {
                            default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "confirm-label", {}, () => [
                                    _createTextVNode(_toDisplayString(_ctx.confirmLabel), 1)
                                ])
                            ]),
                            _: 3
                        }, 8, ["class", "loading"])
                    ])
                ]),
                default: _withCtx(() => [
                    (_ctx.showIcon)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "action-dialog__icon",
                            src: require('@/assets/img/icons/alert-danger.svg'),
                            alt: "",
                            "aria-hidden": "true"
                        }, null, 8, _hoisted_1))
                        : _createCommentVNode("", true),
                    (hasTitle.value)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [
                            _renderSlot(_ctx.$slots, "title", {}, () => [
                                _createTextVNode(_toDisplayString(_ctx.title), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (hasDescription.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                            _renderSlot(_ctx.$slots, "description", {}, () => [
                                _createElementVNode("span", { innerHTML: _ctx.description }, null, 8, _hoisted_4)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 3
            }, 8, ["model-value"]));
        };
    }
});
